import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './volumeBar.scss';

class AudioVolume extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            isOpen: false
        };

        this.preVolume = this.props.volume;
        this.openBar = this.setBarStatus.bind(this, true);
        this.closeBar = this.setBarStatus.bind(this, false);
        this.handleChange = this.handleChange.bind(this);
        this.handleMute = this.handleMute.bind(this);
    }

    setBarStatus(isOpen){
        this.setState({ isOpen });
    }

    handleChange({ target }){
        const volume = parseFloat(target.value);

        this.preVolume = volume;
        this.props.handleVolumeChange(volume);
    }

    handleMute(){
        const volume  = this.props.volume;

        if (volume !== 0){
            this.props.handleVolumeChange(0);
        }
        else {
            this.props.handleVolumeChange(this.preVolume);
        }
    }

    render() {
        const { isOpen }  = this.state,
            isMuted = this.props.volume === 0,
            volumeMidRange = this.props.volume < 0.51,
            inputStyle = { '--min': 0, '--max': 1, '--val': this.props.volume },
            iconClass = classNames('fa', {
                'fa-volume-up': !isMuted && !volumeMidRange,
                'fa-volume-off': isMuted,
                'fa-volume-down': volumeMidRange && !isMuted
            });

        return (

            <div className="volume-bar" onMouseOver={this.openBar} onMouseLeave={this.closeBar}>
                <i className={iconClass} onClick={this.handleMute}/>
                {isOpen && <input id="vol-control"
                    type="range" min="0" max="1" step="0.01"
                    style={inputStyle} value={this.props.volume} onChange={this.handleChange}/>}
            </div>
        );
    }
}

AudioVolume.propTypes = {
    volume: PropTypes.number,
    handleVolumeChange: PropTypes.func
};

export default AudioVolume;
